const sidebarItems = document.querySelectorAll('.editions__sidebar-item');

sidebarItems.forEach(item => {
  const activateItem = () => {    
    if (item.classList.contains('editions__sidebar-item--active')) return;

    const target = document.getElementById(item.dataset.target);
    
    sidebarItems.forEach(i => i.classList.remove('editions__sidebar-item--active'));
    
    document.querySelectorAll('.editions__body').forEach(el => {
      el.classList.add('fade-out');
      el.classList.remove('fade-in');

      setTimeout(() => {
        el.hidden = true;
        el.classList.remove('fade-out');
      }, 200);
    });

    setTimeout(() => {
      target.hidden = false;
      target.classList.add('fade-in');
    }, 200);

    item.classList.add('editions__sidebar-item--active');
  };

  item.addEventListener('click', activateItem);
});
